export enum salesCheckInMode {
    VinCRM = 'vinCrm',
    Standalone = 'standalone'
}

export enum DeepLinks {
    CreditApp = 'CreditApp',
    DocUpload = 'DocUpload',
    DealPdf = 'DealPdf',
    Invalid = 'Invalid'
}
